import React from 'react';
import { css } from '@emotion/react';
import Banner, { Variant as BannerVariant } from '@leafygreen-ui/banner';

// styles
import { ErrorMessage } from './styles/errorMessage';

// utils
import colors from 'js/auth/utils/palette';

// services
import * as errorHelper from 'js/common/services/authErrorHelper';
import intercomService from 'js/common/services/intercomService';

const textLink = css({
  textDecoration: 'none',
  color: colors.link,
  cursor: 'pointer',
});

const getInvalidUserAuthErrorMessage = () => {
  return (
    <>
      Please provide a valid email address and password. If you continue to have issues logging into your account,
      contact our{' '}
      <a
        role="button"
        onClick={() => {
          intercomService.showIntercom();
        }}
        tabIndex={0}
        css={textLink}
      >
        Support team.
      </a>
    </>
  );
};

export default function AuthErrorBanner({
  authErrorCode,
  onPrem = false,
  marketingUrl,
  siteName,
  className,
}: {
  authErrorCode: string;
  onPrem?: boolean;
  marketingUrl?: string;
  siteName: string;
  className?: string;
}) {
  return (
    <Banner variant={BannerVariant.Danger} data-testid="bannerAuthCodeError" className={className}>
      <ErrorMessage>
        {authErrorCode === 'INVALID_USER_AUTH' && !onPrem
          ? getInvalidUserAuthErrorMessage()
          : errorHelper.getErrorMessageFromCode(authErrorCode, { marketingUrl, siteName })}
      </ErrorMessage>
    </Banner>
  );
}
